import { $, $$ } from '@gebruederheitz/wp-frontend-utils';
import _merge from 'lodash-es/merge';
import inViewport from 'in-viewport';

import { Debuggable } from '../utils/Debuggable';

const DEFAULT_OPTIONS = {
    selectors: {
        container: '.competitions-timeline',
        progress: '.competitions-timeline__progress',
        marker: '.competitions-timeline__marker',
    },
    debug: false,
};

export class RegistrationTimeline extends Debuggable {
    constructor(options = {}) {
        super('RegistrationTimeline');

        this.options = _merge(DEFAULT_OPTIONS, options);
        this.container = $()(this.options.selectors.container);

        if (!this.container) return;

        this.animationQueue = [];
        this.container = $()(this.options.selectors.container);
        this.progressElements = $$(this.container)(
            this.options.selectors.progress
        );
        this.markers = $$(this.container)(this.options.selectors.marker);

        this.currentLevel = 0;
        this.curentLevelPercentage = 0;
        this.animationStep = 0;

        this.animate = this.animate.bind(this);

        this.init();
        this.listen();
    }

    addEasing() {
        this.debug.log('Adding easing', {
            first: this.progressElements[0],
            last: this.progressElements[this.currentLevel],
        });

        this.progressElements[0].classList.add('ease-in');
        this.progressElements[this.currentLevel].classList.add('ease-out');
    }

    getPercentage(level) {
        return level === this.currentLevel ? this.currentLevelPercentage : 100;
    }

    addProgressAnimationStep(level) {
        this.debug.log('Initializing level', {
            level,
            endLevel: this.currentLevel,
            percentage: this.currentLevelPercentage,
        });

        const progressElement = this.progressElements[level];
        const percentage = this.getPercentage(level);

        this.animationQueue.push(() => {
            this.debug.log('animation queue element', level, percentage);

            progressElement.addEventListener('transitionend', this.animate, {
                once: true,
            });
            progressElement.style.setProperty(
                '--progress-percentage',
                percentage
            );
        });
    }

    addMarkerAnimationStep(level) {
        this.debug.log('Adding marker animation step');

        const current = level === this.currentLevel;

        this.animationQueue.push(() => {
            this.debug.log(
                'animation queue element (marker)',
                this.markers[this.currentLevel - 1]
            );

            const marker = this.markers[level - 1];
            // marker.addEventListener('transitionend', this.animate, {
            //     once: true,
            // });
            marker.classList.add(current ? 'current' : 'complete');
            this.animate();
        });
    }

    init() {
        // assemble animation queue
        this.currentLevel = parseInt(
            this.container.dataset?.ghwpProgressStep || 0,
            10
        );
        this.currentLevelPercentage =
            this.container.dataset?.ghwpProgressPercentage || 0;

        let processedLevel = 0;

        do {
            if (processedLevel > 0) {
                this.addMarkerAnimationStep(processedLevel);
            }

            this.addProgressAnimationStep(processedLevel);

            ++processedLevel;
        } while (processedLevel <= this.currentLevel);

        // add easing classes to first and last elements
        this.addEasing();
    }

    listen() {
        // attach scroll listener (waypoint)
        inViewport(this.container, () => {
            setTimeout(this.animate, 1000);
        });
    }

    animate() {
        const animationStep = this.animationStep;
        this.debug.log('Animation step', animationStep);

        // total number of animation steps: 1 intro + marker for each step + completed steps + currently active step
        // steps start at 0; levels indicated by currentLevel start at 1
        if (animationStep > this.currentLevel * 2) {
            return;
        }

        ++this.animationStep;
        this.animationQueue[animationStep]();
    }
}
